(function ($) {

    $(document).ready(function () {

        if ($('.image-gallery-carousel .slider-outer').length > 0) {
            setTimeout(function () {
                $(".image-gallery-carousel").css({"opacity": "1"});
            }, 500);

            $('.image-gallery-carousel .slider-outer ').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                infinite: false,
                cssEase: 'linear',
                prevArrow: $('.image-gallery-carousel .navigation .prev'),
                nextArrow: $('.image-gallery-carousel .navigation .next'),
            });

            $(".image-gallery-carousel .slick-arrow").mouseenter(function() {
                $(this).parents().find('.col-wrap').addClass('red-bg');
            }).mouseleave(function() {
                $(this).parents().find('.col-wrap').removeClass('red-bg');
            });

            $(".image-gallery-carousel .col-wrap").mouseenter(function() {
                $(this).parents().find('.slick-arrow').css({'opacity':'1'});
            }).mouseleave(function() {
                $(this).parents().find('.slick-arrow').css({'opacity':'0'});
            });

            $(".image-gallery-carousel .slick-arrow").mouseenter(function() {
                $('.image-gallery-carousel .slick-arrow').css({'opacity':'1'});
            }).mouseleave(function() {
                $('.image-gallery-carousel .slick-arrow').css({'opacity':'0'});
            });
        }
    });
})(jQuery);